module.exports = __webpack_public_path__ + "img/installations.b55b3415.svg";